module.exports = __webpack_public_path__ + "media/images/poster-c2eba7f0.png";